import React, { useEffect, useState, useRef } from "react";
import Draggable from "react-draggable";
import { showAlert } from "../../../config/utils";

import { flattenExecutiveSummaryBandsForLabelCheck } from "./executiveSummaryUtils";

function isSameExecutiveSummaryBand(a, b) {
    if (!a || !b) return false;
    if (a._execClientId != null && b._execClientId != null && String(a._execClientId) === String(b._execClientId)) {
        return true;
    }
    if (a.id != null && b.id != null && String(a.id) === String(b.id)) return true;
    if (a.key != null && b.key != null && String(a.key) === String(b.key)) return true;
    return false;
}

const AddExecutiveSummaryModal = ({
    onCancel,
    onSubmit,
    currentExecutiveSummary = [],
    isImageBand = false,
    isGroupBand = false,
    imageLayoutLabel = "",
    isRename = false,
    initialLabel = "",
    excludeBand = null
}) => {
    const initialState = { label: "", key: "", value: "", id: null, type: "additional" };
    const [inputs, setInputs] = useState(() =>
        isRename && initialLabel ? { ...initialState, label: initialLabel } : initialState
    );
    const [labelError, setLabelError] = useState(null);
    const labelInputRef = useRef(null);

    useEffect(() => {
        const id = window.setTimeout(() => {
            labelInputRef.current?.focus();
        }, 0);
        return () => window.clearTimeout(id);
    }, []);

    useEffect(() => {
        const slug = inputs.label.trim().toLowerCase().replace(/\s+/g, "_");
        setInputs(prev => ({ ...prev, key: slug }));
    }, [inputs.label]);

    useEffect(() => {
        if (inputs.label.trim().length && labelError) setLabelError(false);
    }, [inputs.label, labelError]);

    const handleSubmit = () => {
        const label = inputs.label?.trim();
        const name = label?.toLowerCase();
        if (!label?.length) {
            setLabelError(true);
            return;
        }
        const allBands = flattenExecutiveSummaryBandsForLabelCheck(currentExecutiveSummary);
        if (
            allBands.some(elem => {
                if (excludeBand && isSameExecutiveSummaryBand(elem, excludeBand)) return false;
                return (elem.label || elem.name || "")?.toLowerCase() === name;
            })
        ) {
            showAlert("Field already exists!");
            return;
        }
        const slug = label.toLowerCase().replace(/\s+/g, "_");
        onSubmit({
            ...inputs,
            label,
            key: slug
        });
    };

    const heading = isRename
        ? isGroupBand
            ? "Rename group band"
            : isImageBand
              ? "Rename image band"
              : "Rename text band"
        : isGroupBand
          ? "Add group band"
          : isImageBand
            ? "Add image band"
            : "Add text band";
    const sub = !isRename && isImageBand && imageLayoutLabel ? imageLayoutLabel : "";

    return (
        <div className="modal modal-region modal-view inbox-modal" id="modalId" tabIndex="-1" style={{ display: "block" }}>
            <Draggable handle=".draggable" cancel=".non-draggable">
                <div className="modal-dialog" role="document">
                    <div className="modal-content exec-sum-modal">
                        <div className="modal-header draggable">
                            <h5 className="modal-title">
                                <div className="txt-hed">{heading}</div>
                                {sub ? <div className="text-muted small mt-1 mr-3">{sub}</div> : null}
                            </h5>
                            <button type="button" className="close non-draggable" onClick={onCancel}>
                                <span aria-hidden="true">
                                    <img src="/img/close.svg" alt="" />
                                </span>
                            </button>
                        </div>
                        <div className="modal-body region-otr non-draggable exec-sum-add-modal-body px-4 pb-4">
                            <form
                                noValidate
                                onSubmit={e => {
                                    e.preventDefault();
                                    handleSubmit();
                                }}
                            >
                                {!isRename && isImageBand ? (
                                    <p className="text-muted small mb-3">
                                        Add a label for this section. You can pick images after the band is created.
                                    </p>
                                ) : null}
                                {isGroupBand ? (
                                    <p className="text-muted small mb-3">
                                        {isRename
                                            ? "This heading appears in exports."
                                            : "This heading appears in exports. After creation, add the group summary and nested text or image bands in the group panel."}
                                    </p>
                                ) : null}
                                <div className="form-group exec-sum-add-field">
                                    <label className="font-weight-semibold text-secondary small text-uppercase letter-spacing">
                                        {isGroupBand ? "Group heading" : "Section label"}
                                    </label>
                                    <input
                                        ref={labelInputRef}
                                        type="text"
                                        placeholder="e.g. Building exterior"
                                        value={inputs.label}
                                        onChange={e => setInputs({ ...inputs, label: e.target.value })}
                                        className={`form-control form-control-lg ${labelError ? "error-border" : ""}`}
                                    />
                                </div>
                                <div className="text-right mt-4 pt-2 border-top">
                                    <button type="button" className="btn btn-secondary btnClr mr-2" onClick={onCancel}>
                                        Cancel
                                    </button>
                                    <button type="submit" className="btn btn-primary btnRgion px-4">
                                        {isRename ? "Save" : "Add section"}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </Draggable>
        </div>
    );
};

export default AddExecutiveSummaryModal;
